import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = { class: "text-center mt-5" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Configuration",
          text: "Edit Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "From",
              labelValue: "From",
              placeholderKey: "From",
              placeholderValue: "From",
              modelValue: _ctx.localModel.from,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.from) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Distance (KM)",
              labelValue: "Distance (KM)",
              placeholderKey: "Distance (KM)",
              placeholderValue: "Distance (KM)",
              modelValue: _ctx.localModel.distanceKM,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.distanceKM) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "To",
              labelValue: "To",
              placeholderKey: "To",
              placeholderValue: "To",
              modelValue: _ctx.localModel.to,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.to) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_form_field, {
              type: "select-string",
              labelKey: "Transport type",
              labelValue: "Transport type",
              placeholderKey: "Transport type",
              placeholderValue: "Transport type",
              list: _ctx.transportTypes,
              modelValue: _ctx.localModel.transportType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.transportType) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.international = !_ctx.international))
            }, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Is international",
                  text: "Is international"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.international}])
              }, null, 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create",
                  text: "Create"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit",
                  text: "Edit"
                })
              ]))
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}